export const asDone = {
  data: `<svg width="14" height="14" viewBox="0 0 14 14"  xmlns="http://www.w3.org/2000/svg">
  <path d="M6.99992 0.333496C3.31992 0.333496 0.333252 3.32016 0.333252 7.00016C0.333252 10.6802 3.31992 13.6668 6.99992 13.6668C10.6799 13.6668 13.6666 10.6802 13.6666 7.00016C13.6666 3.32016 10.6799 0.333496 6.99992 0.333496ZM6.99992 12.3335C4.05992 12.3335 1.66659 9.94016 1.66659 7.00016C1.66659 4.06016 4.05992 1.66683 6.99992 1.66683C9.93992 1.66683 12.3333 4.06016 12.3333 7.00016C12.3333 9.94016 9.93992 12.3335 6.99992 12.3335ZM10.0599 4.0535L5.66659 8.44683L3.93992 6.72683L2.99992 7.66683L5.66659 10.3335L10.9999 5.00016L10.0599 4.0535Z"/>
  </svg>
  `,
  name: 'done',
};
